export { default } from "./GeniusContent";
